import React from 'react';
import DocumentTitle from 'react-document-title';
import AXIOS from '../../api/axios';
import { parseQuery } from '../../utils/tools';
import { COURSE_URL } from '../../constants';
import './organization.less';

// 第二教室APP - 机构介绍
export default class Organization extends React.Component {
    constructor(props) {
        super(props);
        const queryObj = parseQuery(window.location.search.slice(1));
        // 优先取切换后的channelId
        if (sessionStorage.getItem("selectChannelId")) {
            this.channelId = sessionStorage.getItem("selectChannelId")
        } else {
            this.channelId = queryObj.channelid;
        }
        this.state = {
            name: '', // 名称
            logoUrl: '', // logo图片
            description: '', // 描述
            picUrls: [], // 介绍图片
            changeStatus: 0 // 切换状态 0-不可切换 1-可切换
        }
    }
    componentDidMount() {
        AXIOS.getOrgInfo(this.channelId, (res, err) => {
            if (err) {
                console.log(err)
            } else {
                this.setState({
                    name: res.name || '',
                    logoUrl: res.logoUrl || '',
                    description: res.description || '',
                    picUrls: res.picUrls || [],
                    changeStatus: res.changeStatus || 0
                })
            }
        })
    }
    handleSelect = () => {
        const { history } = this.props;
        history.push({
            pathname: `${COURSE_URL}/lesson2/org-select`,
            search: `?channelId=${this.channelId}`
        })
    }
    render() {
        const { name, logoUrl, description, picUrls, changeStatus } = this.state
        return <DocumentTitle title="机构中心">
            <div className="organization-wrap">
                {logoUrl ? <img src={logoUrl} alt="" className="organization-logo"/> : null}
                <p className="organization-name">{name}</p>
                <p className="organization-desc">{description}</p>
                {
                    picUrls.map(item => (
                        <img src={item} alt="" className="organization-img" key={item}/>
                    ))
                }
                {
                    !!changeStatus && <div className="organization-select-btn" onClick={this.handleSelect}>切换机构</div>
                }
            </div>
        </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/lesson2/organization.jsx